import { addEvent, removeEvent, triggerEvent } from '../utils/events';
const KEY_ENTER = 13;
const KEY_ESCAPE = 27;
export class Search {

  /**
   * @param  {Dom}    search             container to hold search component
   * @param  {String} searchButton       search button element
   */

  constructor(search, isOpen, allowClose, alwaysOpenDownInNav) {
    this.search = search;
    if (!this.isEverythingOk()) {
      return;
    }
    this.searchToggle = search.querySelector('.search-toggle');
    this.searchToggleIcon = search.querySelector('.search-toggle > i');
    this.searchInput = search.querySelector('.search-input');
    this.searchInputBox = search.querySelector('.search-input > input');
    this.searchButton = search.querySelector('.search-input i');
    this.isOpen = isOpen;
    this.allowClose = allowClose;
    this.alwaysOpenDownInNav = alwaysOpenDownInNav;
    // Initialize search component
    this.init();
  }

  init() {
    if (this.searchToggle && this.allowClose) {
      this.search.classList.add('search--allow-close');
    } else if (this.isOpen) {
      this.searchToggle.classList.add('hide');
    }
    if (this.isOpen) {
      this.search.classList.add('search--open');
      this.searchToggleIcon.classList.remove('fa-search');
      this.searchToggleIcon.classList.add('fa-close');
    }
    if (this.alwaysOpenDownInNav) {
      this.search.classList.add('search--nav-down');
    }
    if (this.search.parentNode.classList.contains('nav__action')) {
      this.search.parentNode.style.position = 'static';
    }
    addEvent(this.searchToggle, 'click', this.toggle.bind(this));
    addEvent(this.searchInputBox, 'focus', this.selectText.bind(this));
    addEvent(this.searchInputBox, 'keydown', this.keyPress.bind(this));
    addEvent(this.searchButton, 'click', this.doSearch.bind(this));
  }

  selectText() {
    this.searchInputBox.select();
  }

  keyPress(event) {
    if (event.which === KEY_ENTER) {
      this.doSearch();
    }
    if (event.which === KEY_ESCAPE && this.allowClose) {
      this.toggle();
    }
  }

  doSearch() {
    triggerEvent(this.search, 'do.commonui.search');
  }

  toggle() {
    if (this.isOpen === false) {
      this.search.classList.add('search--open');
      if (this.allowClose === false) {
        this.searchToggle.classList.add('hide');
      } else {
        this.searchToggleIcon.classList.remove('fa-search');
        this.searchToggleIcon.classList.add('fa-close');
      }
      this.searchInputBox.focus();
      this.isOpen = true;
      triggerEvent(this.search, 'open.commonui.search');
    } else {
      this.search.classList.remove('search--open');
      this.searchToggleIcon.classList.remove('fa-close');
      this.searchToggleIcon.classList.add('fa-search');
      this.isOpen = false;
      triggerEvent(this.search, 'close.commonui.search');
    }
  }

  destroy() {
    if (this.searchButton) {
      removeEvent(this.searchButton, 'click', this.toggle.bind(this));
    }
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this.search) {
      console.warn('CommonUI - Search - There\'s no search component found');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */
}

/**
 * Creates a new instance
 * @param  {Object} config
 */
export default function initSearch(config = {}) {
  const {
    selector = '.js-search',
    openOnLoad = false,
    allowClose = true,
    alwaysOpenDownInNav = false,
  } = config;
  let searches = null;
  if (typeof selector === 'string') {
    for (const search of document.querySelectorAll(selector)) {
      searches = new Search(search, openOnLoad, allowClose, alwaysOpenDownInNav);
    }
  }
  return searches;
}



// WEBPACK FOOTER //
// ./js/components/Search.js